module.exports = __webpack_public_path__ + "media/images/landing/browser_planning.en-original-cef33abe08f5b595fdddc0dcd61f85c7.png";